import React, {Component} from 'react';

export class BaseDashboard extends Component {
    getLineupsQuantity() {
        const {rawLineups, filterLineupsByKeyPlayerStackCombinations} = this.props;

        return filterLineupsByKeyPlayerStackCombinations?.hasCheckedCombinations()
            ? filterLineupsByKeyPlayerStackCombinations.getLineupsQuantity()
            : rawLineups.getQuantity();
    }
}
